import { bootToolPage } from '../lib/boot-tool'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('touch')
document.body.insertAdjacentHTML('beforeend', stageMarkup({ controls: ['exit', 'hide'] }))
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

let maxSeen = 0

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  const stage = document.querySelector<HTMLElement>('[data-stage-root]')
  const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')
  if (!stage || !canvas) return
  canvas.style.background = '#101418'
  canvas.style.touchAction = 'none'

  const dots = new Map<number, HTMLDivElement>()

  const syncCount = () => {
    const countNode = document.querySelector('[data-touch-count]')
    const maxNode = document.querySelector('[data-touch-max]')
    if (countNode) countNode.textContent = String(dots.size)
    if (maxNode) maxNode.textContent = String(maxSeen)
    const label = stage.querySelector('[data-stage-label]')
    if (label) label.textContent = `${dots.size} ${t(locale, 'touches_label')}`
  }

  const onStart = (event: PointerEvent) => {
    canvas.setPointerCapture(event.pointerId)
    const el = document.createElement('div')
    el.style.cssText =
      'position:absolute;width:54px;height:54px;margin:-27px 0 0 -27px;border-radius:50%;border:2px solid #7fffd4;background:rgb(127 255 212 / 0.2);display:grid;place-items:center;font:600 14px Outfit,sans-serif;color:#eafff7;pointer-events:none'
    el.textContent = String(event.pointerId % 100)
    el.style.left = `${event.clientX}px`
    el.style.top = `${event.clientY}px`
    canvas.appendChild(el)
    dots.set(event.pointerId, el)
    maxSeen = Math.max(maxSeen, dots.size)
    syncCount()
  }

  const onMove = (event: PointerEvent) => {
    const el = dots.get(event.pointerId)
    if (!el) return
    el.style.left = `${event.clientX}px`
    el.style.top = `${event.clientY}px`
  }

  const onEnd = (event: PointerEvent) => {
    dots.get(event.pointerId)?.remove()
    dots.delete(event.pointerId)
    syncCount()
  }

  canvas.addEventListener('pointerdown', onStart)
  canvas.addEventListener('pointermove', onMove)
  canvas.addEventListener('pointerup', onEnd)
  canvas.addEventListener('pointercancel', onEnd)

  const close = openStage(stage, {
    onExit: () => {
      canvas.removeEventListener('pointerdown', onStart)
      canvas.removeEventListener('pointermove', onMove)
      canvas.removeEventListener('pointerup', onEnd)
      canvas.removeEventListener('pointercancel', onEnd)
      close()
    },
  })
})
